import { render } from "./InspectionInfo.vue?vue&type=template&id=1028f29c"
import script from "./InspectionInfo.vue?vue&type=script&lang=js"
export * from "./InspectionInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/web/vina_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__